"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledButton = styled_components_1.default.button `
  min-width: ${({ buttonWidth }) => buttonWidth};
  background-color: ${({ buttonTheme, theme }) => (buttonTheme === 'light' ? theme.white : theme.denimBlue)};
	border: ${({ theme }) => `1px solid ${theme.denimBlue}`};
  color: ${({ buttonTheme, theme }) => (buttonTheme === 'light' ? theme.denimBlue : theme.white)};
  margin: 20px;
  padding: 12px;
	font-size: ${({ theme }) => `${theme.baseFontSize}`};
	font-family: ${({ theme }) => `${theme.defaultFontFamily}`}, Helvetica, sans-serif;

  &:hover {
		${({ buttonTheme, theme }) => (`
    	background-color: ${buttonTheme === 'light' ? theme.white : theme.ceruleanBlue};
			color: ${(buttonTheme === 'light' ? theme.ceruleanBlue : theme.white)};
			border-color: ${theme.ceruleanBlue};
    	cursor: pointer;
		`)}
  }

	&:focus {
  	outline-offset: -4px;
		outline: ${({ buttonTheme, theme }) => (buttonTheme === 'light' ? `2px solid ${theme.ceruleanBlue}` : `2px solid ${theme.white}`)};
		background-color: ${({ buttonTheme, theme }) => buttonTheme === 'light' ? theme.white : theme.ceruleanBlue};
		color: ${({ buttonTheme, theme }) => (buttonTheme === 'light' ? theme.ceruleanBlue : theme.white)};
		border: ${({ theme }) => `1px solid ${theme.ceruleanBlue}`};
	}

	&:disabled {
		background-color: ${({ theme }) => theme.lightGray3};
		border-color: ${({ theme }) => theme.lightGray3};
		cursor: default;
	}

  @media (max-width: 41em) {
	width: 100%;
	min-width: auto;
    font-size: ${({ theme }) => `${theme.bigFontSize}`};
		margin: 15px 0 15px 0;
  }
`;
const defaultProps = {
    type: 'button',
    label: '',
    dataTestId: 'button',
    buttonWidth: '204px',
    buttonTheme: 'dark',
};
const Button = ({ type, label, dataTestId, buttonWidth, onClick, disabled, buttonTheme }) => {
    return (react_1.default.createElement(StyledButton, { type: type, "data-testid": dataTestId, buttonWidth: buttonWidth, onClick: onClick, disabled: disabled, buttonTheme: buttonTheme }, label));
};
exports.Button = Button;
exports.Button.defaultProps = defaultProps;
